import React from 'react';

import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  IconButton,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useStyle } from '../style';
import moment from 'moment';

const SalesLinesModal = ({ open, onClose, salesLines = [] }) => {
    const classes = useStyle();
    console.log(salesLines[0]?.outletSales_lines,"salesLinestest");
    const salesdata = salesLines[0]|| salesLines
    return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: '#fff',
          padding: 2,
          maxWidth: 1200,
          margin: 'auto',
          marginTop: '10%',
          borderRadius: 1,
          boxShadow: 24,
          overflow:'auto'
        }}
      >
        <div className="flex justify-end">
        {/* {salesdata && (
              <Grid className="my-1">
                <Typography sx={{ marginBlock: 0.5 }}>
                  Bill No : <strong>{salesdata.docno}</strong>
                </Typography>
                <Typography>
                  Bill Date : <strong>{ moment(salesdata.docdate).format("DD-MM-YYYY") }</strong>
                </Typography>
              </Grid>
            )} */}
            {/* <div className="flex my-1" style={{ flexDirection: 'column' }}>
              <Typography>
                Sales Man : <strong>{salesdata.sales_man_name}</strong> -{' '}
                <strong>{salesdata.sales_man_code}</strong>
              </Typography>
              <Typography>
                Payment Mode : <strong>{salesdata.mode}</strong>
              </Typography>
            </div> */}
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
             <TableContainer className={classes.tblRoot} sx={{width: '100%',maxHeight: 400, overflow:"auto"}} >
                  <Table stickyHeader  className={classes.table}  sx={{ maxHeight: 350, overflowY: 'auto'  }}>
                    <TableHead className={classes.tblHeader}>
                      <TableRow className={classes.tablrow}>
                        {/* <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell> */}
                        <TableCell className={classes.tblCell}>Bill No</TableCell>
                        <TableCell className={classes.tblCell}>Bill Date</TableCell>
                        <TableCell className={classes.tblCell}>Product Name</TableCell>
                        <TableCell className={classes.tblCell}>Category</TableCell>
                        <TableCell className={classes.tblCell}>Subcategory</TableCell>
                        <TableCell className={classes.tblCell}>Type Name</TableCell>
                        <TableCell className={classes.tblCell}>Barcode</TableCell>
                        <TableCell className={classes.tblCell}>Procode</TableCell>
        
                        <TableCell className={classes.tblCell}>Rate</TableCell>
                        <TableCell className={classes.tblCell}>Mrp</TableCell>
                        <TableCell className={classes.tblCell}>Qty</TableCell>
                        <TableCell className={classes.tblCell}>Gst %</TableCell>
                        <TableCell className={classes.tblCell}>Gst Amt</TableCell>
                        <TableCell className={classes.tblCell}>Cess %</TableCell>
                        <TableCell className={classes.tblCell}>Cess Amt</TableCell>
                        <TableCell className={classes.tblCell}>Dis %</TableCell>
                        <TableCell className={classes.tblCell}>Dis Amt</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody >
                   
                      {salesLines.map((line)=>(
                        <TableRow className={classes.tablrow}  key={line.id}>
                         {/* <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}></TableCell> */}
               
                        <TableCell>{line.docno}</TableCell>
                        <TableCell>{ moment(line.docdate).format("DD-MM-YYYY") }</TableCell>
                        <TableCell>{line.pro_name}</TableCell>
                        <TableCell>{line.category_name}</TableCell>
                        <TableCell>{line.subcategory_name}</TableCell>
                        <TableCell>{line.type_name}</TableCell>
                        <TableCell>{line.barcode}</TableCell>
                        <TableCell>{line.pro_code}</TableCell>

                         <TableCell>{line.rate}</TableCell>

                         <TableCell>{line.mrp}</TableCell>
                         <TableCell>{line.qty}</TableCell>
                         <TableCell>{line.gst_per}</TableCell>
                         <TableCell>{parseFloat(line.gst_amt).toFixed(0)}</TableCell>
                         <TableCell>{line.cess_per}</TableCell>
                         <TableCell>{line.cess_amt}</TableCell>
                         <TableCell>{line.dis_per}</TableCell>
                         <TableCell>{line.dis_amt}</TableCell>
                       </TableRow>
                       ))
                 }
                    
          
                    </TableBody>
            
                  </Table>
                    
                </TableContainer>
      </Box>
    </Modal>
  );
};

export default SalesLinesModal;
